export const API_ERROR_DEFAULT =
  "Unknown error, please contact technical support";

export const API_ERROR_NO_SERVER_RESPONSE =
  "No response from the server. Please try again later.";

export const API_ERROR_SENDING_REQUEST = "Error sending request to API";
